import * as z from "zod";
import { gql } from "graphql-request";
import { Image, ImageFragment } from "../image";
import { Sys, SysFragment } from "../sys";
import { UnifiedButton, UnifiedButtonFragment } from "../unifiedButton";

export const EsportCarouselEventEntry = z.object({
  __typename: z.literal("EsportCarouselEventEntry"),
  sys: Sys,
  entryTitle: z.string().nullable(),
  entrySubtitle: z.string().nullable(),
  carouselImage: Image.nullable(),
  carouselImageEn: Image.nullable(),
  ctaButtonsCollection: z
    .object({
      items: z.array(UnifiedButton).nullish(),
    })
    .nullish(),
});

export type EsportCarouselEventEntry = z.infer<typeof EsportCarouselEventEntry>;

export const EsportCarouselEventEntryFragment = gql`
  fragment EsportCarouselEventEntryFragment on EsportCarouselEventEntry {
    __typename
    sys {
      ...SysFragment
    }
    entryTitle
    entrySubtitle
    carouselImage {
      ...ImageFragment
    }
    carouselImageEn: carouselImage(locale: "en") {
      ...ImageFragment
    }
    ctaButtonsCollection {
      items {
        __typename
        ... on UnifiedButton {
          ...UnifiedButtonFragment
        }
      }
    }
  }
  ${ImageFragment}
  ${UnifiedButtonFragment}
  ${SysFragment}
`;
